import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TpvDashboardRepository } from '@app/domain/ports/tpv/tpv-dashboard.repository';
import {
  TpvDashboardQuery,
  TpvDashboardSummary,
} from '@app/domain/models/tpv/tpv-dashboard-summary.model';
import { TpvDashboardDto } from '@app/data/dtos/tpv/dashboard-summary.dto';
import { mapTpvDashboardSummary } from '@app/data/mappers/tpv/dashboard-summary.mapper';
import { tpvUrl } from '@app/data/tpv/tpv-api.config';
import { TpvEnvelope, unwrapTpv } from '@app/data/tpv/tpv-envelope';
import { toHttpParams } from './tpv-http.util';

/**
 * `GET /api/v1/tpv/dashboard/` (Suite). Auth Bearer vía interceptores estándar.
 * El scope de comercios lo deriva Suite del usuario; el front solo manda fechas
 * y, opcionalmente, `id_merchant` para drill-down.
 */
@Injectable()
export class TpvDashboardRemoteDataSource extends TpvDashboardRepository {
  private readonly http = inject(HttpClient);

  override getDashboard(query: TpvDashboardQuery = {}): Observable<TpvDashboardSummary> {
    const params = toHttpParams({
      start_date: query.startDate,
      end_date: query.endDate,
      id_merchant: query.idMerchant,
    });
    return this.http
      .get<TpvEnvelope<TpvDashboardDto>>(tpvUrl('dashboard/'), { params })
      .pipe(map((raw) => mapTpvDashboardSummary(unwrapTpv<TpvDashboardDto>(raw))));
  }
}
